module.exports = "/images/crackedSeal.png?d810dd19cb5814d35cca5349e10d0974";